import React, { Component } from "react";
import { connect } from 'react-redux';
import {Modal, Button} from 'react-bootstrap';
import messages from './SubscribeModal.messages';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { getOneSignalInfo } from "../../../../../helpers/Utils";
import { isMobile } from "../../../../../helpers/Utils";

import * as actions from '../../../../../redux/user/actions';

import type User from '../../models/User';


type Props = {
  user: ?User;
  onModalClose: () => void;
  alertMessage: string;
}

type StateProps = {
  activeProject: ?Project;
};

type State = {

};


class SubscribeModal extends Component {
  props: Props;
  state: State = {
  };

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    return (
      <div>
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>{this.isMobile() ? messages.mobileAlertTitle : messages.alertTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.props.alertMessage}</Modal.Body>
          <Modal.Footer>
            <Button onClick={this.props.onModalClose}>Cancel</Button>
              <LinkContainer exact to="/subscription">
                <button
                  type='submit'
                  className="btn btn-primary">
                  {this.isMobile() ? messages.mobileUpgradeButton : messages.upgrade}
                </button>
              </LinkContainer>
          </Modal.Footer>
        </Modal.Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {

  }
}

export default connect(mapStateToProps, actions)(SubscribeModal);



// WEBPACK FOOTER //
// ./src/views/user/components/modals/subscribe-modal/SubscribeModal.js